import classNames from 'classnames';
import { ScommesseEsitoTipoBox } from 'components/scommesseEsitoTipoBox';
import { selectIsVisualizzazioneEstesa } from 'features/settings/selectors';
import {
  useInfoAggiuntivaBilanciata,
  useInfoAggiuntivaDataByScommessaKey,
  useInfoAggiuntivaIndex,
  useIsAvvenimento,
} from 'features/sport/hooks';
import useWindowSize from 'hooks/useWindowSize';
import { SizeInfoAggiuntiva } from 'lib/api/sport/sportScommesseBySlugResponse';
import { useTypedSelector } from 'lib/centralStore';
import React, { memo, useEffect, useState } from 'react';
import { isTruthy } from 'utility/functions';
import { ScommesseLeafItem } from '../components/cells';
import { ScommesseTableQuotaSelect } from '../components/scommesseTableQuotaSelect';
import { ScommesseTipoProps } from '../types';
import styles from './ScommesseTipoEsitiOverThree.module.scss';
import { Skeleton } from './Skeleton';

export const Scommessa = memo(function Scommessa({
  hasHeader,
  scommessaKey,
  infoAggiuntivaKey: infoAggiuntivaKeyProp,
  gtagAction,
}: ScommesseTipoProps) {
  const [esitoKey, selectEsitoKey] = useState<string | undefined>();
  const infoAggData = useInfoAggiuntivaDataByScommessaKey(scommessaKey);
  const { infoAggiuntivaKey: infoAggiuntivaKeyState } = infoAggData ?? {};

  const infoAggiuntivaKey = infoAggiuntivaKeyProp ?? infoAggiuntivaKeyState;

  const infoAggIndex = useInfoAggiuntivaIndex(infoAggiuntivaKey);
  const { esitoKeyList } = infoAggIndex ?? {};

  const { showHeader } = useInfoAggiuntivaBilanciata(scommessaKey);

  const { isMobile } = useWindowSize();
  const isAvvenimento = useIsAvvenimento();
  const isEstesa = useTypedSelector(selectIsVisualizzazioneEstesa);

  useEffect(() => {
    if (!isTruthy(esitoKeyList?.length)) {
      selectEsitoKey(undefined);
      return;
    }

    if (!esitoKey || !esitoKeyList?.includes(esitoKey)) {
      selectEsitoKey(esitoKeyList?.[0]);
    }
  }, [esitoKey, esitoKeyList]);

  // in case esitoKeyList is empty -> renders EsitiOverThreeSkeleton to draw placeholders (ScommesseDropdownSimple does not)
  if (isTruthy(esitoKeyList?.length) && esitoKey) {
    return (
      <React.Fragment data-testid={`ScommesseTipoEsitiOverThree: ${scommessaKey}`}>
        <ScommesseTableQuotaSelect
          showHeader={showHeader}
          size={SizeInfoAggiuntiva.Large}
          type={ScommesseLeafItem.Quota}
          className={classNames(styles.select, { [styles.selectAvvenimento]: isAvvenimento })}
          containerClassName={classNames({ [styles.selectContainerAvvenimento]: isAvvenimento })}
          optionsKeys={esitoKeyList!}
          headerList={[]}
          scommessaKey={scommessaKey}
          selectedOptionKey={esitoKey}
          infoAggiuntivaKey={infoAggiuntivaKey}
          onOptionSelected={selectEsitoKey}
        />
        <ScommesseEsitoTipoBox
          key={esitoKey}
          keyEsito={esitoKey}
          scommessaKey={scommessaKey}
          infoAggiuntivaKey={infoAggiuntivaKey}
          showHeader={isMobile || isEstesa}
          showHeaderOutside={hasHeader && !isMobile}
          gtagAction={gtagAction}
          className={classNames({ [styles.containerAvvenimento]: isAvvenimento })}
          classNameButton={classNames({ [styles.boxAvvenimento]: isAvvenimento })}
        />
      </React.Fragment>
    );
  }

  return <Skeleton hasHeader={hasHeader} scommessaKey={infoAggiuntivaKey} />;
});
